package data.search_data

import models.SearchData

// Search suggestions (78)
val PyramidsGizaSearchSuggestions = listOf(
    "maatkare",
    "cylinder",
    "seal",
    "iii",
    "alloy",
    "travertine",
    "faience",
    "jasper",
    "impressed",
    "stela",
    "khasekhemwy",
    "clay",
    "royal",
    "glass",
    "fragment",
    "bronzes",
    "relief",
    "red",
    "cosmetic",
    "bronze",
    "steatite",
    "egyptian",
    "horus",
    "black",
    "lower",
    "wood",
    "inlay",
    "isis",
    "upper",
    "scarab",
    "jar",
    "pendant",
    "hatshepsut",
    "statue",
    "ptah",
    "bowl",
    "nesut",
    "god",
    "plaque",
    "figure",
    "man",
    "amun",
    "greywacke",
    "model",
    "leaf",
    "copper",
    "goddess",
    "miscellaneous",
    "lion",
    "silver",
    "king",
    "linen",
    "seker",
    "standing",
    "ivory",
    "group",
    "glazed",
    "quartzite",
    "funerary",
    "dwarf",
    "paint",
    "limestone",
    "sealing",
    "statuette",
    "amulet",
    "woman",
    "image",
    "depicting",
    "unfired",
    "bity",
    "alabaster",
    "child",
    "pottery",
    "document",
    "mud",
    "egypt",
    "gold",
    "queen",
    "name",
    "carnelian",
    "head",
    "pataikos",
    "block",
    "pair",
    "inscribed",
)

// Machu Picchu (366)
val PyramidsGizaSearchData = listOf(
    SearchData(
        -2650,
        547434,
        "Copper pin?",
        "cosmetic pin (?)|copper alloy|",
        "eg/mobile-large/01.4.41_EGDP011664.jpg",
        1.78
    ),
    SearchData(
        -347,
        243717,
        "Red jasper amulet of the sun on the horizon",
        "amulet, sun on horizon|jasper, red|gold and silver",
        "gr/mobile-large/DP121805.jpg",
        0.75
    ),
    SearchData(
        -2649,
        543870,
        "Figure of a male beer-maker",
        "statuette, male beer-maker|limestone, paint|",
        "eg/mobile-large/20.2.1.JPG",
        0.73
    ),
    SearchData(
        -2649,
        561720,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/LC-10_130_1618_EGDP032392.jpg",
        0.67
    ),
    SearchData(
        -2551,
        543895,
        "Archers",
        "relief, archers|limestone, paint|",
        "eg/mobile-large/DT259178.jpg",
        1.25
    ),
    SearchData(
        650,
        326230,
        "Textile fragment: walking ram with a neckband and fluttering ribbons",
        "textile|wool, cotton|",
        "an/mobile-large/ra1977.232.R.jpg",
        0.52
    ),
    SearchData(
        -347,
        243760,
        "Faience amulet in the form of a lion-headed deity",
        "amulet, bast|clay, glazed|gold and silver",
        "gr/mobile-large/DP121824.jpg",
        0.75
    ),
    SearchData(
        -2475,
        545826,
        "Headless statue of Babaef as older man",
        "statue, babaef as older man|limestone|",
        "eg/mobile-large/64.66.2_EGDP014893.jpg",
        0.50
    ),
    SearchData(
        -2520,
        548547,
        "Relief fragment showing fishing scene",
        "relief, fishing scene|limestone|",
        "eg/mobile-large/58.161.jpg",
        1.95
    ),
    SearchData(
        -347,
        243809,
        "Faience button seal",
        "button seal|clay, glazed|gold and silver",
        "gr/mobile-large/DP121847.jpg",
        1.33
    ),
    SearchData(
        -1249,
        249678,
        "Glass pendant ornament in the form of a pair of birds",
        "ornament in the form of two ducks|glass|glass",
        "gr/mobile-large/DP121789.jpg",
        1.33
    ),
    SearchData(-664, 553106, "Bottle", "bottle|glass|", "eg/mobile-large/DP-24757-001.jpg", 0.77),
    SearchData(
        -2650,
        570768,
        "Clay jar sealing impressed faintly with name of Khasekhemwy",
        "sealing, jar|clay (unfired)|",
        "eg/mobile-large/01.4.102_EGDP012135.jpg",
        1.40
    ),
    SearchData(
        -347,
        243731,
        "Faience amulet in the form of the dwarf god Pataikos",
        "amulet, ptah-seker|clay, glazed|gold and silver",
        "gr/mobile-large/DP121811.jpg",
        0.75
    ),
    SearchData(
        -347,
        244463,
        "Bronze statuette of Osiris",
        "statuette of osiris|bronze|bronzes",
        "gr/mobile-large/DP20092.jpg",
        0.92
    ),
    SearchData(
        -1465,
        573652,
        "Model Ax from the Foundation Deposit for Hatshepsut\"s Tomb",
        "model ax|bronze or copper alloy, wood|",
        "eg/mobile-large/30.8.3.jpg",
        1.33
    ),
    SearchData(-2649, 543922, "Ewer", "vessel, ewer|copper|", "eg/mobile-large/26-2-15.jpg", 1.63),
    SearchData(
        -2465,
        543929,
        "Miniature ointment jar",
        "ointment jar, miniature|gneiss|",
        "eg/mobile-large/LC-07_228_91_EGDP033551.jpg",
        0.67
    ),
    SearchData(
        -1250,
        547899,
        "Kneeling official",
        "statuette, kneeling official|bronze|",
        "eg/mobile-large/DP139142.jpg",
        1.00
    ),
    SearchData(-2557, 545776, "Ball", "ball|clay or mud|", "eg/mobile-large/20-2-49-50.jpg", 1.95),
    SearchData(
        125,
        547951,
        "Portrait of the Boy Eutyches",
        "panel painting, eutyches|encaustic on wood, paint|",
        "eg/mobile-large/DT564.jpg",
        0.47
    ),
    SearchData(
        -2650,
        547428,
        "Model harpoon",
        "model harpoon|copper alloy|",
        "eg/mobile-large/01.4.35_EGDP011631.jpg",
        1.50
    ),
    SearchData(
        -1800,
        544326,
        "Coffin of Khnumnakht",
        "coffin, khnumnakht|wood, paint|",
        "eg/mobile-large/DP354909.jpg",
        1.36
    ),
    SearchData(
        -1465,
        549727,
        "Scarab Inscribed for the King of Upper and Lower Egypt Maatkare (Hatshepsut)",
        "scarab; maatkare, nesut bity, ankh; notched back|steatite (glazed)|",
        "eg/mobile-large/27.3.247_bot.jpg",
        1.01
    ),
    SearchData(
        -1390,
        767349,
        "Document Sealing",
        "sealing, upper egypt, lower egypt, amun-re|mud|",
        "eg/mobile-large/SC-PA_206.jpg",
        1.27
    ),
    SearchData(
        -995,
        243763,
        "Faience Ushabti",
        "amulet, ushabti|clay, glazed|gold and silver",
        "gr/mobile-large/DP121826.jpg",
        0.75
    ),
    SearchData(
        349,
        464049,
        "Gold Necklace with Amphora (Vase) Pendant",
        "necklace|gold|metalwork-gold",
        "md/mobile-large/LC_17_190_1643s01.jpg",
        0.76
    ),
    SearchData(
        -2650,
        547425,
        "Model ax-head",
        "model ax head|copper alloy|",
        "eg/mobile-large/01.4.32_EGDP011629.jpg",
        1.00
    ),
    SearchData(
        -2650,
        547426,
        "Model adze blade",
        "model adze blade|copper alloy|",
        "eg/mobile-large/01.4.33_EGDP011637.jpg",
        1.50
    ),
    SearchData(
        -1390,
        767353,
        "Document Sealing",
        "sealing, upper egypt, lower egypt, amun-re|mud|",
        "eg/mobile-large/SC-PA_210.jpg",
        1.12
    ),
    SearchData(
        -2650,
        570767,
        "Clay jar sealing impressed faintly with name of Khasekhemwy",
        "sealing, jar|clay (unfired)|",
        "eg/mobile-large/01.4.101_EGDP012122.jpg",
        1.40
    ),
    SearchData(
        -2500,
        543888,
        "Large high-shouldered jar",
        "jar|travertine (egyptian alabaster)|",
        "eg/mobile-large/DT227156.jpg",
        0.80
    ),
    SearchData(
        -2465,
        543928,
        "Miniature \"nw\" pot",
        "pot, \"nw\" pot, miniature|gneiss|",
        "eg/mobile-large/LC-07_228_92_EGDP033556.jpg",
        0.67
    ),
    SearchData(
        -2650,
        547430,
        "Model chisel",
        "model chisel|copper alloy|",
        "eg/mobile-large/01.4.37_EGDP011641.jpg",
        1.78
    ),
    SearchData(
        -100,
        577944,
        "King\"s Head with Egyptian Headdress but Greek Hair and Features",
        "head, king, greek hair|gabbro|",
        "eg/mobile-large/DP246577.jpg",
        1.33
    ),
    SearchData(
        -1282,
        547704,
        "Head of a goddess",
        "head, goddess|quartzite|",
        "eg/mobile-large/DT4632.jpg",
        0.80
    ),
    SearchData(
        -2520,
        543896,
        "Fragmentary Face of King Khafre",
        "head fragment, king khafre|travertine (egyptian alabaster)|",
        "eg/mobile-large/DT11751.jpg",
        0.77
    ),
    SearchData(
        -2465,
        543902,
        "Statue of Demedji and Hennutsen",
        "statue, seated pair, demedji, hennutsen|limestone, paint|",
        "eg/mobile-large/DT521.jpg",
        0.80
    ),
    SearchData(
        -2551,
        543909,
        "Reserve head",
        "head, reserve|limestone|",
        "eg/mobile-large/48.156(1).JPG",
        0.66
    ),
    SearchData(
        -215,
        549187,
        "Hedgehog on box pendant",
        "pendant, hedgehog on box|gold|",
        "eg/mobile-large/DP356247.jpg",
        0.87
    ),
    SearchData(
        -181,
        548310,
        "The Goddess Isis and her Son Horus",
        "statuette of isis with the horus child|faience|",
        "eg/mobile-large/DP241036.jpg",
        0.75
    ),
    SearchData(
        -2649,
        561722,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/LC-10_130_1612_EGDP032319.jpg",
        0.67
    ),
    SearchData(
        1250,
        831188,
        "Icon of the Virgin and Child, Hodegetria variant",
        "|tempera on wood|paintings-icons",
        "md/mobile-large/DP-22753-001.jpg",
        0.74
    ),
    SearchData(
        6,
        330095,
        "Pyx Fragments with the Multiplication of the Loaves and Fishes",
        "pyx fragments|elephant ivory|ivories-elephant",
        "md/mobile-large/kn314a.jpg",
        1.20
    ),
    SearchData(
        -155,
        243774,
        "Faience amulet in the form of a tree frog",
        "amulet, frog|faience|gold and silver",
        "gr/mobile-large/DP121833.jpg",
        0.75
    ),
    SearchData(
        -1344,
        547692,
        "Head of a princess from a group statue",
        "head, amarna princess|quartzite|",
        "eg/mobile-large/DP137930.jpg",
        1.00
    ),
    SearchData(
        -664,
        243713,
        "Lapis lazuli heart amulet",
        "amulet pendant, heart|lapis lazuli|gold and silver",
        "gr/mobile-large/DP121803.jpg",
        0.75
    ),
    SearchData(
        -664,
        550945,
        "Amulet: Crown of Upper Egypt",
        "amulet, crown, upper egypt|faience|",
        "eg/mobile-large/LC-24_4_4_EGDP028726.jpg",
        0.67
    ),
    SearchData(
        -2650,
        547440,
        "Child\"s bracelet",
        "bracelet, child\"s|gold|",
        "eg/mobile-large/01.4.2_01-20-01.jpg",
        1.69
    ),
    SearchData(
        -300,
        587759,
        "God\"s Wife Tagerem, daughter of the priest Imhotep",
        "statue, lower half of a woman|limestone|",
        "eg/mobile-large/DP224656.jpg",
        0.75
    ),
    SearchData(
        -2650,
        551834,
        "Ivory label incised with an early hieroglyph that may be the image of a bundle of arrows",
        "label, bundle of arrows|wood, ink|",
        "eg/mobile-large/01.4.162_EGDP011678.jpg",
        0.67
    ),
    SearchData(
        -347,
        243770,
        "Faience amulet in the form of a cat",
        "amulet, cat|clay, glazed|gold and silver",
        "gr/mobile-large/DP121831.jpg",
        0.75
    ),
    SearchData(
        -2420,
        543901,
        "Nikare with his Wife and Daughter",
        "statue group, nikare, wife, daughter|limestone, paint|",
        "eg/mobile-large/DT242488.jpg",
        0.80
    ),
    SearchData(
        -347,
        243781,
        "Faience djed-pillar amulet",
        "amulet pendant, djed sign|clay, glazed|gold and silver",
        "gr/mobile-large/DP121841.jpg",
        0.75
    ),
    SearchData(
        -995,
        243764,
        "Faience Overseer Ushabti",
        "amulet, ushabti|clay, glazed|gold and silver",
        "gr/mobile-large/DP121827.jpg",
        0.75
    ),
    SearchData(
        -182,
        250532,
        "Faience statuette of Aphrodite",
        "amulet, aphrodite|faience|miscellaneous-faience",
        "gr/mobile-large/DP121795.jpg",
        0.75
    ),
    SearchData(
        -1425,
        329799,
        "Head with tripartite wig, probably from a shabti",
        "head of a shabti|steatite or serpentinite|",
        "eg/mobile-large/LC-2021_41_34_EGDP032381.jpg",
        0.80
    ),
    SearchData(
        -2575,
        561157,
        "Relief Depicting Personified Estates from the Tomb of Akhtihotep",
        "relief, akhtihotep|limestone, paint|",
        "eg/mobile-large/58.44.2b.jpg",
        0.75
    ),
    SearchData(
        -1981,
        556559,
        "Figure of a Female Dwarf",
        "statuette, dwarf, female|faience|",
        "eg/mobile-large/1972.48_front.jpg",
        0.78
    ),
    SearchData(
        -2465,
        552614,
        "Statue, young boy",
        "statue, young boy|limestone|",
        "eg/mobile-large/66.195.jpg",
        0.55
    ),
    SearchData(
        -2465,
        552238,
        "Oarsmen and an Official",
        "relief, oarsmen|limestone, paint traces|",
        "eg/mobile-large/DP251956.jpg",
        0.57
    ),
    SearchData(
        -1295,
        590955,
        "Two Bottles in the Form of Pomegranates",
        "bottle, pomegranate|glass, opaque|",
        "eg/mobile-large/DP112594.jpg",
        1.00
    ),
    SearchData(
        -995,
        243734,
        "Faience two-sided amulet in the form of the dwarf god Pataikos",
        "amulet, ptah-seker|clay, glazed|gold and silver",
        "gr/mobile-large/DP121814.jpg",
        0.75
    ),
    SearchData(
        -349,
        548360,
        "Torso of a High General",
        "statue, torso, striding general|meta-greywacke|",
        "eg/mobile-large/DT3997.jpg",
        0.80
    ),
    SearchData(
        -1452,
        547772,
        "Ritual Statuette of Thutmose III",
        "statuette, kneeling king, thutmose iii|black bronze, gold inlay|",
        "eg/mobile-large/DT537.jpg",
        0.80
    ),
    SearchData(
        -1422,
        560965,
        "Goddess of Lower Egypt",
        "statuette, standing goddess, lower egypt|ivory|",
        "eg/mobile-large/LC-22_9_5_EGDP028548.jpg",
        0.67
    ),
    SearchData(
        -1750,
        544249,
        "Model of a House",
        "model, house, soul house|pottery|",
        "eg/mobile-large/07.231.10.jpg",
        1.02
    ),
    SearchData(
        -300,
        551285,
        "Plaque Depicting a Goddess or Queen, and on Opposite Side a King",
        "sculptor\"s modeland/or  votive, goddess or queen, king on other side|limestone, paint|",
        "eg/mobile-large/DP243478.jpg",
        0.74
    ),
    SearchData(
        -1371,
        547777,
        "Male god",
        "statue, god|granodiorite|",
        "eg/mobile-large/DP-24214-001.jpg",
        0.61
    ),
    SearchData(
        -2649,
        572178,
        "Linen Cloth",
        "linen cloth|linen|",
        "eg/mobile-large/12.187.50_EGDP020601.jpg",
        1.50
    ),
    SearchData(
        -1465,
        559860,
        "Scarab Inscribed King of Upper and Lower Egypt, Sobek Crocodile",
        "scarab; two gods upper and lower egypt, crocodile; notched back|steatite (glazed)|",
        "eg/mobile-large/27.3.291_bot.jpg",
        1.04
    ),
    SearchData(
        -1961,
        544185,
        "Seated Statue of King Senwosret I",
        "statue, senwosret i, seated|greywacke|",
        "eg/mobile-large/25.6 front.jpg",
        0.40
    ),
    SearchData(
        -2960,
        547442,
        "Bull\"s leg",
        "furniture leg, bull\"s leg|ivory|",
        "eg/mobile-large/LC-06_1162_2_EGDP033541.jpg",
        0.72
    ),
    SearchData(
        -1360,
        554751,
        "Sealing from a Jar with the Name of a king Amenhotep",
        "jar sealing, amenhotep iii|mud, pottery, paint|",
        "eg/mobile-large/36.2.4_EGDP011892_1.jpg",
        0.67
    ),
    SearchData(
        -1810,
        560903,
        "Tile inlay fragment",
        "tile inlay fragment|faience|",
        "eg/mobile-large/DP241474.jpg",
        0.75
    ),
    SearchData(
        -2465,
        543883,
        "Relief with running troops",
        "relief, running troops|limestone, paint|",
        "eg/mobile-large/15.3.1163_EGDP015380.jpg",
        1.49
    ),
    SearchData(
        -2575,
        543903,
        "Striding Figure",
        "statue, striding man|quartzite, paint|",
        "eg/mobile-large/DT206639.jpg",
        0.68
    ),
    SearchData(
        -1371,
        547775,
        "Head of a Hippopotamus",
        "head, hippopotamus|travertine (egyptian alabaster) with traces of gesso and red pigment|",
        "eg/mobile-large/DT4210.jpg",
        0.91
    ),
    SearchData(
        -1390,
        767345,
        "Document Sealing",
        "sealing, amun-re, upper egypt, lower egypt|mud|",
        "eg/mobile-large/SC-PA_202.jpg",
        0.81
    ),
    SearchData(
        1285,
        447000,
        "Mosque Lamp for the Mausoleum of Amir Aydakin al-\"Ala\"i al-Bunduqdar",
        "mosque lamp|glass; blown, folded foot, applied handles, enameled, and gilded|glass",
        "is/mobile-large/DP170366.jpg",
        0.75
    ),
    SearchData(
        -1344,
        544680,
        "Pair of Clappers",
        "music, clapper, arm, hand|hippopotamus ivory|",
        "eg/mobile-large/DT11781.jpg",
        0.79
    ),
    SearchData(
        -266,
        551786,
        "Book of the Dead of the Priest of Horus, Imhotep (Imuthes)",
        "papyrus, funerary, book of the dead, imouthes, imhotep, imuthes|papyrus, ink|",
        "eg/mobile-large/2-35.9.20a–w_EGDP014589-4594.jpg",
        4.12
    ),
    SearchData(
        -1991,
        544024,
        "Cosmetic jar",
        "cosmetic jar|travertine (egyptian alabaster)|",
        "eg/mobile-large/26.7.1435.jpg",
        1.39
    ),
    SearchData(
        -6,
        547804,
        "Head of Augustus",
        "head, augustus|faience|",
        "eg/mobile-large/DP247261.jpg",
        0.75
    ),
    SearchData(
        -1000,
        551038,
        "Amulet Plaque with Figure of Thoth",
        "amulet, djedmutesankh, thoth|faience|",
        "eg/mobile-large/62361.jpg",
        1.21
    ),
    SearchData(
        -2649,
        561726,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/LC-10_130_1615_EGDP032340.jpg",
        0.67
    ),
    SearchData(
        -2575,
        543912,
        "Corner of niche from the tomb of Akhtihotep",
        "false door niche block, akhtihotep, corner|limestone, paint|",
        "eg/mobile-large/58.123_01.jpg",
        0.59
    ),
    SearchData(
        -1919,
        590947,
        "Coffins and Mummy of the Lady Nephthys",
        "coffin, mummy, nephthys|painted wood, cartonnage, linen, human remains, mummification material|",
        "eg/mobile-large/11.150.15a-b_0028.jpg",
        1.50
    ),
    SearchData(
        -2649,
        552016,
        "Jar",
        "jar|pottery|",
        "eg/mobile-large/28.2.11_EGDP010293.jpg",
        0.70
    ),
    SearchData(
        -2650,
        547432,
        "Model chisel",
        "model chisel|copper alloy|",
        "eg/mobile-large/01.4.39_EGDP011643.jpg",
        1.78
    ),
    SearchData(
        -2458,
        543882,
        "King Sahure Accompanied by a Divine Figure",
        "statue group, king sahure, nome god|gneiss|",
        "eg/mobile-large/DP-1691-03.jpg",
        0.73
    ),
    SearchData(
        -166,
        559969,
        "Funerary amulet depicting one of the Four Sons of Horus, Imsety",
        "amulet, four sons of horus, imsety|glass|",
        "eg/mobile-large/LC-30_8_283_EGDP027476.jpg",
        0.67
    ),
    SearchData(
        -595,
        546748,
        "Statue of Harbes, called Psamtiknefer, son of Ptahhotep",
        "statue, harbes|meta-greywacke|",
        "eg/mobile-large/DP-14816-003.jpg",
        0.75
    ),
    SearchData(
        -1371,
        544853,
        "Whip Handle in the Shape of a Horse",
        "whip handle, horse|ivory, garnet, paint|",
        "eg/mobile-large/DP-17703-001.jpg",
        1.33
    ),
    SearchData(
        -2000,
        545879,
        "Head of a King, Possibly Seankhkare Mentuhotep III",
        "head, royal, nemes, mentuhotep iii (?)|limestone|",
        "eg/mobile-large/DP323866.jpg",
        0.83
    ),
    SearchData(
        -2100,
        555983,
        "Blade inscribed for the Overseer of Upper Egypt Idi",
        "blade|unalloyed copper|",
        "eg/mobile-large/29.2.8_EGDP014604.jpg",
        0.67
    ),
    SearchData(
        -1197,
        544752,
        "Head of King Seti II Wearing the Blue Crown",
        "head, amenmesse, seti ii, blue crown|quartzite, paint|",
        "eg/mobile-large/34.2.2_EGDP011841.jpg",
        0.67
    ),
    SearchData(
        -1390,
        767343,
        "Document Sealing",
        "sealing, amun-re, upper egypt, lower egypt|mud|",
        "eg/mobile-large/SC-PA_200.jpg",
        1.02
    ),
    SearchData(
        -1465,
        559857,
        "Scarab Inscribed King of Upper and Lower Egypt",
        "scarab; nesut bity; simple back|steatite (glazed)|",
        "eg/mobile-large/27.3.288_bot.jpg",
        1.16
    ),
    SearchData(
        -995,
        243801,
        "Faience amulet plaque of Isis nourishing a pharaoh",
        "amulet plaque, isis nourishing a king|clay, glazed|gold and silver",
        "gr/mobile-large/DP121844.jpg",
        0.75
    ),
    SearchData(
        -950,
        243740,
        "Faience amulet of Bes image",
        "amulet, bes|clay, glazed|gold and silver",
        "gr/mobile-large/DP121817.jpg",
        0.75
    ),
    SearchData(
        -2575,
        547737,
        "Lintel block from the false door of Mery\"s chapel",
        "false door, lintel block, mery\"s mastaba|limestone|",
        "eg/mobile-large/67.50_EGDP015829.jpg",
        2.09
    ),
    SearchData(
        -1537,
        547950,
        "Head of Ahmose I",
        "head, king ahmose|limestone|",
        "eg/mobile-large/DP140854.jpg",
        0.75
    ),
    SearchData(
        -1891,
        544319,
        "Writing board",
        "writing board|wood, gesso, paint|",
        "eg/mobile-large/DP234742.jpg",
        1.34
    ),
    SearchData(
        -2520,
        552235,
        "Sarcophagus of Mindjedef",
        "sarcophagus, mindjedef|granite|",
        "eg/mobile-large/54.80a-b_EGDP015827.jpg",
        1.50
    ),
    SearchData(
        -2649,
        568268,
        "Inscribed seal impression",
        "sealing|clay or mud|",
        "eg/mobile-large/LC-10_130_978_EGDP033231.jpg",
        1.25
    ),
    SearchData(
        -2650,
        570770,
        "Jar sealing",
        "sealing|clay (unfired)|",
        "eg/mobile-large/01.4.163_EGDP012148.jpg",
        1.00
    ),
    SearchData(
        -182,
        250531,
        "Faience statuette of Aphrodite",
        "amulet, aphrodite|faience|miscellaneous-faience",
        "gr/mobile-large/DP132034.jpg",
        0.75
    ),
    SearchData(
        -1182,
        545919,
        "Figure of an Asiatic captive",
        "asiatic captive, furniture decoration|ivory, red and pink pigment, white ground|",
        "eg/mobile-large/66.99.50_EGDP020841.jpg",
        0.67
    ),
    SearchData(
        -1390,
        767344,
        "Document Sealing",
        "sealing, amun-re, upper egypt, lower egypt|mud|",
        "eg/mobile-large/SC-PA_201.jpg",
        0.85
    ),
    SearchData(
        -2465,
        548225,
        "Foot Amulet",
        "amulet, foot|carnelian|",
        "eg/mobile-large/DP109378.jpg",
        1.17
    ),
    SearchData(
        600,
        473068,
        "Necklace and Pendant Cross",
        "necklace|rock crystal, silver mount|lapidary work-crystal",
        "md/mobile-large/DP-14824-001.jpg",
        0.72
    ),
    SearchData(
        -2575,
        545820,
        "Seated man",
        "statue, seated man|limestone|",
        "eg/mobile-large/62.201.1_01.jpg",
        0.67
    ),
    SearchData(
        -1465,
        547562,
        "Carpenter\"s Adze from a Foundation Deposit for Hatshepsut\"s Temple",
        "adze, carpenter, hatshepsut, maatkare|wood, bronze or copper alloy, leather|",
        "eg/mobile-large/96.4.7.rp.jpg",
        1.32
    ),
    SearchData(
        -1390,
        767341,
        "Document Sealing",
        "sealing, amun-re, upper egypt, lower egypt|mud|",
        "eg/mobile-large/SC-PA_198.jpg",
        1.24
    ),
    SearchData(
        -181,
        544118,
        "Cat Statuette intended to contain a mummified cat",
        "statuette, cat|leaded bronze|",
        "eg/mobile-large/DP245141.jpg",
        0.75
    ),
    SearchData(
        -1859,
        544186,
        "Senwosret III as a Sphinx",
        "sphinx, senwosret iii; 12th-dyn-king|gneiss|",
        "eg/mobile-large/DP247658.jpg",
        1.33
    ),
    SearchData(
        -2512,
        549541,
        "Recumbent Lion",
        "statue, lion recumbent|granite|",
        "eg/mobile-large/DT2860.jpg",
        1.66
    ),
    SearchData(
        -50,
        547905,
        "A child god, probably Harpokrates",
        "statuette, standing harpokrates|leaded bronze, formerly gilded|",
        "eg/mobile-large/DP139143.jpg",
        1.00
    ),
    SearchData(
        -664,
        545368,
        "Amulet: Crown of Lower Egypt",
        "amulet, crown of lower egypt|faience|",
        "eg/mobile-large/LC-10_130_1822_EGDP028703.jpg",
        0.67
    ),
    SearchData(
        -1550,
        329943,
        "Head of Ptah",
        "|egyptian blue, gold leaf|",
        "eg/mobile-large/DP-21434-002.jpg",
        0.74
    ),
    SearchData(
        -2650,
        547399,
        "Clay jar sealing Clay jar sealing impressed with name of Khasekhemwy",
        "sealing, jar|clay (unfired)|",
        "eg/mobile-large/01.4.99_EGDP012141.jpg",
        1.00
    ),
    SearchData(
        165,
        547698,
        "Plaster Portrait Mask of a Youth",
        "mask, youth portrait|plaster, linen, paint, lapis lazuli, glass|",
        "eg/mobile-large/DT278928.jpg",
        1.26
    ),
    SearchData(
        -1465,
        559830,
        "Scarab Inscribed for the King of Upper and Lower Egypt Maatkare (Hatshepsut)",
        "scarab; maatkare, nesut bity; notched back|steatite (glazed)|",
        "eg/mobile-large/27.3.245_bot.jpg",
        0.97
    ),
    SearchData(
        -199,
        246747,
        "Terracotta head of a woman",
        "head of a woman|terracotta|terracottas",
        "gr/mobile-large/DP121878.jpg",
        1.00
    ),
    SearchData(
        -2649,
        570883,
        "Linen Cloth",
        "linen cloth|linen|",
        "eg/mobile-large/12.187.47_EGDP020600.jpg",
        1.50
    ),
    SearchData(
        -1371,
        544068,
        "Gazelle",
        "figurine, gazelle|ivory (elephant), wood, blue-pigment inlay|",
        "eg/mobile-large/DP-17702-001.jpg",
        1.07
    ),
    SearchData(
        -1344,
        545756,
        "Goblet Inscribed with the Names of King Amenhotep IV and Queen Nefertiti",
        "cup, amenhotep iv, nefertiti. goblet|travertine (egyptian alabaster)|",
        "eg/mobile-large/DT11826.jpg",
        0.80
    ),
    SearchData(
        -1353,
        544683,
        "Statue of two men and a boy that served as a domestic icon",
        "statue group, two men, boy|limestone, paint|",
        "eg/mobile-large/DP206147.jpg",
        0.75
    ),
    SearchData(
        -1390,
        767352,
        "Document Sealing",
        "sealing, upper egypt, lower egypt, amun-re|mud|",
        "eg/mobile-large/SC-PA_209.jpg",
        1.42
    ),
    SearchData(
        -347,
        243726,
        "Jasper amulet of headrest",
        "amulet, pillow charm|jasper|gold and silver",
        "gr/mobile-large/DP121808.jpg",
        1.33
    ),
    SearchData(
        -828,
        544874,
        "Statuette of Amun",
        "statuette, amun, standing, god|gold|",
        "eg/mobile-large/DT553.jpg",
        0.80
    ),
    SearchData(
        -2649,
        561718,
        "Cylinder seal",
        "cylinder seal|gray stone|",
        "eg/mobile-large/26-7-12.jpg",
        0.68
    ),
    SearchData(
        -167,
        243747,
        "Faience amulet of Mut with double crown",
        "amulet, mut with double crown|clay, glazed|gold and silver",
        "gr/mobile-large/DP121820.jpg",
        0.75
    ),
    SearchData(
        -2649,
        561721,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/LC-10_130_1617_EGDP032354.jpg",
        0.67
    ),
    SearchData(
        -1368,
        249682,
        "Glass pendant in the form of crescent horns",
        "pendant in the form of a crescent|glass|glass",
        "gr/mobile-large/DP121031.jpg",
        0.75
    ),
    SearchData(
        -1412,
        554920,
        "Funerary Cone of the Fourth Prophet of Amun Kaemamun",
        "cone, circular impression, kaemamun, seal-bearer, lower egypt, prophet, amun|pottery|",
        "eg/mobile-large/30.6.50-acc.jpg",
        1.06
    ),
    SearchData(
        -1981,
        546288,
        "Flail of Hapiankhtifi",
        "scepter, hapiankhtifi|wood, gold leaf, carnelian, faience|",
        "eg/mobile-large/DP354266.jpg",
        0.74
    ),
    SearchData(
        -1295,
        330125,
        "Bald-headed Man Wearing Gold Collars",
        "|steatite or schist|",
        "eg/mobile-large/DP-20855-002.jpg",
        0.75
    ),
    SearchData(
        549,
        446236,
        "Pendant Cross",
        "pendant|bone|ivories and bone",
        "is/mobile-large/sf12-182-109s1.jpg",
        0.80
    ),
    SearchData(
        -2630,
        543904,
        "Wall tiles from the funerary apartments of king Djoser",
        "tile, apartments of king djoser|faience|",
        "eg/mobile-large/DT258569.jpg",
        0.67
    ),
    SearchData(
        300,
        466583,
        "Sarcophagus Lid with Last Judgement",
        "sarcophagus lid|marble|sculpture-stone",
        "md/mobile-large/DT271481.jpg",
        5.41
    ),
    SearchData(
        -1452,
        544860,
        "Drinking Cup",
        "cup, nuzi, mitanni, button-base|glassy faience, gold|",
        "eg/mobile-large/1228_3B_01BBr2.jpg",
        0.75
    ),
    SearchData(
        -2649,
        574279,
        "Shell Amulet",
        "amulet, shell|carnelian|",
        "eg/mobile-large/10.130.2436_EGDP021795.jpg",
        1.00
    ),
    SearchData(
        -1990,
        544039,
        "Cosmetic Vessel in the Shape of a Cat",
        "vessel, cat|travertine (egyptian alabaster), copper, quartz crystal, paint|",
        "eg/mobile-large/DT532.jpg",
        0.80
    ),
    SearchData(
        449,
        466266,
        "Dionysos",
        "plaque|bone|bone",
        "md/mobile-large/sf1993-516-1s1.jpg",
        0.46
    ),
    SearchData(
        -594,
        590745,
        "Barque Sphinx",
        "barque sphinx|leaded bronze|",
        "eg/mobile-large/DP247004.jpg",
        1.33
    ),
    SearchData(
        -181,
        544864,
        "Statuette of the Goddess Taweret",
        "statuette of taweret|glassy faience|",
        "eg/mobile-large/DP243443.jpg",
        0.75
    ),
    SearchData(
        -1745,
        556561,
        "Magic Wand",
        "magic wand|ivory|",
        "eg/mobile-large/86.1.91_EGDP011957.jpg",
        1.78
    ),
    SearchData(
        -202,
        329895,
        "Statuette of a flutist",
        "bronze, non-royal, private, flutist|copper alloy|",
        "eg/mobile-large/LC-2021_41_117_EGDP032491.jpg",
        0.67
    ),
    SearchData(-2557, 545777, "Ball", "ball|clay or mud|", "eg/mobile-large/20-2-49-50.jpg", 1.95),
    SearchData(
        -1465,
        559831,
        "Scarab Inscribed King of Upper and Lower Egypt Maatkare, Having Dominion",
        "scarab; maatkare, nesut bity, wasti; detailed back|steatite (glazed)|",
        "eg/mobile-large/27.3.249_bot.jpg",
        0.85
    ),
    SearchData(
        -1390,
        544794,
        "Stela of Senu",
        "stela, senu, imsety, hapy|limestone|",
        "eg/mobile-large/LC-12_182_39_EGDP029823.jpg",
        0.67
    ),
    SearchData(
        -1367,
        244340,
        "Bronze handle of a jug",
        "handle of a jug|bronze|bronzes",
        "gr/mobile-large/DP2297.jpg",
        1.00
    ),
    SearchData(
        -2417,
        577367,
        "Tomb chapel of Raemkai: South wall of the entrance corridor",
        "relief, tomb chapel, raemkai, offering bearers, statute, slaughtering cattle|limestone, paint|",
        "eg/mobile-large/EG599.jpg",
        0.99
    ),
    SearchData(
        -1465,
        549730,
        "Scarab Inscribed King of Upper and Lower Egypt Maatkare, Having Dominion",
        "scarab; maatkare, nesut bity, wasti; detailed back|steatite (glazed)|",
        "eg/mobile-large/27.3.248_bot.jpg",
        0.85
    ),
    SearchData(
        -867,
        561047,
        "Wedjat Eye Amulet",
        "amulet, wedjat eye|faience, aragonite|",
        "eg/mobile-large/26.7.1032_EGDP011735.jpg",
        1.50
    ),
    SearchData(
        -1339,
        544689,
        "Canopic Jar (07.226.1) with a Lid Depicting a Queen (30.8.54)",
        "canopic jar lid to the jar 07.226.1 of kiya, secondary queen of akhenaten|travertine (egyptian alabaster), blue glass, obsidian, unidentified stone|",
        "eg/mobile-large/DT227703.jpg",
        0.68
    ),
    SearchData(
        -2465,
        543894,
        "Relief Fragment with a Ship Under Sail",
        "relief, ship under sail|limestone, paint traces|",
        "eg/mobile-large/DT256967.jpg",
        1.25
    ),
    SearchData(
        -1390,
        767348,
        "Document Sealing",
        "sealing,  upper egypt, lower egypt, amun-re|mud|",
        "eg/mobile-large/SC-PA_205.jpg",
        1.27
    ),
    SearchData(
        -1981,
        546286,
        "Model Broad Collar of Hapiankhtifi",
        "broad collar, hapiankhtifi|faience, blue green and black|",
        "eg/mobile-large/12.183.12_0013.jpg",
        1.55
    ),
    SearchData(
        -2649,
        570882,
        "Linen Cloth",
        "linen cloth|linen|",
        "eg/mobile-large/12.187.46_EGDP020594.jpg",
        1.50
    ),
    SearchData(
        -347,
        243780,
        "Faience djed-pillar amulet",
        "amulet pendant, djed sign|clay, glazed|gold and silver",
        "gr/mobile-large/DP121839.jpg",
        0.75
    ),
    SearchData(
        -995,
        243730,
        "Faience amulet in the form of the dwarf god Pataikos",
        "amulet, ptah-seker|clay, glazed|gold and silver",
        "gr/mobile-large/DP121810.jpg",
        0.75
    ),
    SearchData(
        1750,
        31890,
        "Pair of Stirrups",
        "stirrups|iron, gold|equestrian equipment-stirrups",
        "aa/mobile-large/LC-36_25_534a_b-002.jpg",
        1.78
    ),
    SearchData(
        -2649,
        547738,
        "Relief Fragment depicting offering bearers from the mastaba of Idut, daughter of King Unas (?)",
        "relief, offering bearers|limestone|",
        "eg/mobile-large/66-99-80.jpg",
        1.98
    ),
    SearchData(
        -2539,
        551091,
        "False door niche block of Merykhufu",
        "false door niche block, merykhufu|limestone|",
        "eg/mobile-large/68.13a-b_EGDP015343.jpg",
        1.41
    ),
    SearchData(
        -700,
        587591,
        "Head of a goddess, probably Mut, for attachment to a processional barque (?)",
        "head, goddess mut, protome|cupreous alloy, gold leaf, formerly inlaid|",
        "eg/mobile-large/DP206149.jpg",
        0.75
    ),
    SearchData(
        -2649,
        545798,
        "Jar sealing",
        "sealing, jar|mud or clay|",
        "eg/mobile-large/LC-60_95_EGDP033245.jpg",
        1.00
    ),
    SearchData(
        -347,
        243761,
        "Faience amulet in the form of a lion-headed deity",
        "amulet, bast|clay, glazed|gold and silver",
        "gr/mobile-large/DP231279.jpg",
        0.75
    ),
    SearchData(
        -1353,
        545907,
        "Funerary Figure of Isis, Singer of the Aten",
        "funerary figure, shabti, isis, singer, aten|limestone|",
        "eg/mobile-large/66.99.38_EGDP013435.jpg",
        0.67
    ),
    SearchData(
        -351,
        544888,
        "Nectanebo II Offers to Osiris Hemag",
        "relief, nectanebo ii|granodiorite|",
        "eg/mobile-large/12.182.4c_EGDP011900.jpg",
        1.50
    ),
    SearchData(
        -1350,
        239937,
        "Glass krateriskos (unguent jar)",
        "krateriskos|glass|glass",
        "gr/mobile-large/DP153938.jpg",
        1.00
    ),
    SearchData(
        -2649,
        561727,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/LC-10_130_1614_EGDP032333.jpg",
        0.67
    ),
    SearchData(
        -167,
        243729,
        "Faience amulet in the form of the dwarf god Pataikos",
        "amulet, ptah-seker|clay, glazed|gold and silver",
        "gr/mobile-large/DP121809.jpg",
        0.75
    ),
    SearchData(
        -289,
        547900,
        "Miniature broad collar",
        "necklace, broad collar, miniature|gold, carnelian, turquoise, lapis lazuli|",
        "eg/mobile-large/DP139141.jpg",
        1.00
    ),
    SearchData(
        -3000,
        543866,
        "Libation Dish Depicting Ka-Arms Presenting an Ankh-Sign",
        "dish, libation|greywacke|",
        "eg/mobile-large/DP249937.jpg",
        0.75
    ),
    SearchData(
        167,
        245500,
        "Bronze statuette of a horseman",
        "statuette of a horseman|bronze|bronzes",
        "gr/mobile-large/DP20160.jpg",
        1.00
    ),
    SearchData(
        -249,
        246749,
        "Terracotta head of a woman",
        "head of a woman|terracotta|terracottas",
        "gr/mobile-large/DP121879.jpg",
        1.00
    ),
    SearchData(
        -2649,
        544001,
        "Offering slab for seven oils of Ankhwadjes",
        "offering slab, seven oils|travertine (egyptian alabaster)|",
        "eg/mobile-large/11-150-1a.jpg",
        2.42
    ),
    SearchData(
        -2551,
        569692,
        "Specimen of mortar from the Great Pyramid",
        "mortar fragment, giza pyramid|mortar (shell, quartz, bricks)|",
        "eg/mobile-large/23.187_EGDP017918.jpg",
        1.33
    ),
    SearchData(
        -995,
        243733,
        "Faience amulet in the form of the dwarf god Pataikos",
        "amulet, ptah-seker|clay, glazed|gold and silver",
        "gr/mobile-large/DP121813.jpg",
        0.75
    ),
    SearchData(
        -2394,
        561064,
        "Ewer, from basin and ewer set",
        "ewer|arsenical copper, surface enriched in arsenic|",
        "eg/mobile-large/LC-26_9_13_EGDP029546.jpg",
        1.50
    ),
    SearchData(
        -181,
        590939,
        "Statuette of Anubis",
        "anubis, jackal-headed|plastered and painted wood|",
        "eg/mobile-large/38.5_EGDP022863.jpg",
        0.67
    ),
    SearchData(
        -347,
        243798,
        "Faience Wedjat-eye amulet",
        "amulet, eye, udjati|clay, glazed|gold and silver",
        "gr/mobile-large/DP121843.jpg",
        1.33
    ),
    SearchData(
        -349,
        547556,
        "Inlay Depicting \"Horus of Gold\"",
        "inlay, falcon, golden horus|faience|",
        "eg/mobile-large/DP240847.jpg",
        0.74
    ),
    SearchData(
        -2650,
        547431,
        "Model adze blade",
        "model adze blade|copper alloy|",
        "eg/mobile-large/01.4.38_EGDP011640.jpg",
        1.78
    ),
    SearchData(
        -484,
        243719,
        "Red jasper amulet of tyet",
        "amulet, girdle tie|jasper, red|gold and silver",
        "gr/mobile-large/DP121807.jpg",
        0.75
    ),
    SearchData(
        -167,
        253575,
        "Wood statuette of Hekate",
        "statuette of hekate|wood, juniper|miscellaneous-wood",
        "gr/mobile-large/DP145604.jpg",
        1.00
    ),
    SearchData(
        -3000,
        544077,
        "Lion Cub",
        "statuette, animal, lion|quartzite|",
        "eg/mobile-large/DP244929.jpg",
        0.74
    ),
    SearchData(
        -350,
        548439,
        "Inlay Depicting a Falcon with Spread Wings",
        "inlay, falcon|faience|",
        "eg/mobile-large/DP243445.jpg",
        1.33
    ),
    SearchData(
        -274,
        547699,
        "Head Attributed to Arsinoe II",
        "head of a statue of arsinoe ii|limestone (indurated)|",
        "eg/mobile-large/DT10849.jpg",
        0.80
    ),
    SearchData(
        -265,
        548230,
        "Face attributed to Ptolemy II Philadelphos or a contemporary",
        "head fragment, ptolemy ii|greywacke|",
        "eg/mobile-large/DP-24213-001.jpg",
        0.75
    ),
    SearchData(
        -347,
        244461,
        "Bronze statuette of Isis with infant Horus",
        "statuette of isis and horus|bronze|bronzes",
        "gr/mobile-large/DP20096.jpg",
        0.92
    ),
    SearchData(
        350,
        473395,
        "Lute",
        "lute|wood with traces of paint|woodwork-miscellany",
        "md/mobile-large/DP302641.jpg",
        1.33
    ),
    SearchData(
        -2465,
        688030,
        "Hand and Foot Amulets",
        "amulet, foot|carnelian|",
        "eg/mobile-large/DP109378.jpg",
        1.17
    ),
    SearchData(
        -2649,
        552017,
        "Jar with flat base",
        "jar, flat base|pottery|",
        "eg/mobile-large/28.2.6_EGDP010303.jpg",
        0.91
    ),
    SearchData(
        -347,
        243768,
        "Faience amulet in the form of a lion",
        "amulet, lion|clay, glazed|gold and silver",
        "gr/mobile-large/DP121830.jpg",
        1.33
    ),
    SearchData(
        -2462,
        545827,
        "Head of male statue, perhaps Babaef",
        "head, male statue, perhaps babaef|granite|",
        "eg/mobile-large/64.66.3_01.jpg",
        0.72
    ),
    SearchData(
        -2551,
        543891,
        "Relief with the head of a female personification of an estate",
        "relief, female personification of an estate|limestone|",
        "eg/mobile-large/DT259179.jpg",
        0.80
    ),
    SearchData(
        -1109,
        329785,
        "Two-Sided Plaque with Gazelles",
        "|faience|",
        "eg/mobile-large/LC-2021_41_20_EGDP032448.jpg",
        1.50
    ),
    SearchData(
        -1272,
        554769,
        "Stelophorous Statue of Bay",
        "bay, stela, stelephorous|limestone|",
        "eg/mobile-large/DP231293.jpg",
        0.75
    ),
    SearchData(
        -2551,
        543892,
        "Relief with a billy goat",
        "relief, billy goat|limestone|",
        "eg/mobile-large/DT212583.jpg",
        1.25
    ),
    SearchData(
        -484,
        243718,
        "Red jasper amulet of tyet",
        "amulet, girdle tie|jasper, red|gold and silver",
        "gr/mobile-large/DP121806.jpg",
        0.75
    ),
    SearchData(
        -2650,
        547395,
        "Tweezers",
        "tweezers|copper alloy|",
        "eg/mobile-large/01.4.31_EGDP011693.jpg",
        1.78
    ),
    SearchData(
        -2649,
        570919,
        "Amulet, leg",
        "amulet, leg|carnelian|",
        "eg/mobile-large/15-43-336.jpg",
        0.61
    ),
    SearchData(
        -2575,
        543899,
        "The King\"s Acquaintances Memi and Sabu",
        "statue, standing pair, memi, sabu|limestone, paint|",
        "eg/mobile-large/DT8836.jpg",
        0.80
    ),
    SearchData(
        -167,
        244503,
        "Bronze statuette of Horus",
        "statuette of horus as an infant|bronze|bronzes",
        "gr/mobile-large/DP20109.jpg",
        0.96
    ),
    SearchData(
        -347,
        243744,
        "Faience amulet of Isis and Horus",
        "amulet, isis|clay, glazed|gold and silver",
        "gr/mobile-large/DP121819.jpg",
        0.75
    ),
    SearchData(
        -347,
        243766,
        "Faience amulet of Ra Horakhty",
        "amulet, hawk|clay, glazed|gold and silver",
        "gr/mobile-large/DP121829.jpg",
        0.75
    ),
    SearchData(
        -262,
        249622,
        "Glass mosaic relief fragment",
        "mosaic inlay|glass|glass",
        "gr/mobile-large/DP121782.jpg",
        0.75
    ),
    SearchData(
        -2550,
        558193,
        "Speciman of Mortar from the Great Pyramid",
        "mortar, giza pyramid|mortar|",
        "eg/mobile-large/17.6.143_EGDP017920.jpg",
        1.33
    ),
    SearchData(
        -1514,
        587532,
        "Relief with the Head of Amenhotep I",
        "relief, head, king, amenhotep i|limestone|",
        "eg/mobile-large/45.2.7_EGDP011785.jpg",
        1.00
    ),
    SearchData(
        1000,
        451717,
        "Bowl with Eagle",
        "bowl|earthenware; luster-painted on opaque white glaze|ceramics",
        "is/mobile-large/DP221332.jpg",
        0.75
    ),
    SearchData(
        -1882,
        544232,
        "Pectoral and Necklace of Sithathoryunet with the Name of Senwosret II",
        "necklace, pectoral, sithathoryunet-view-jewelry, senwosret ii|gold, carnelian, lapis lazuli, turquoise, garnet (pectoral)  gold, carnelian, lapis lazuli, turquoise, green feldspar (necklace)|",
        "eg/mobile-large/DT531.jpg",
        1.25
    ),
    SearchData(
        -712,
        587760,
        "Kushite priest wearing garment with leopard\"s head and tassels, subsequently adapted for a king",
        "statue, priest|leaded bronze, gold leaf|",
        "eg/mobile-large/DP236108.jpg",
        0.75
    ),
    SearchData(
        -995,
        243778,
        "Faience amulet",
        "amulet pendant|clay, glazed|gold and silver",
        "gr/mobile-large/DP121838.jpg",
        0.75
    ),
    SearchData(
        -2649,
        561725,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/26-7-8.jpg",
        0.85
    ),
    SearchData(
        1287,
        450409,
        "Enameled and Gilded Bottle",
        "bottle|glass, greenish; blown, folded foot; enameled and gilded|glass",
        "is/mobile-large/DP170374.jpg",
        0.75
    ),
    SearchData(
        -1492,
        548731,
        "Cosmetic Jar Sealed with Linen",
        "jar|pottery, linen|",
        "eg/mobile-large/LC-36_3_68_EGDP026072.jpg",
        1.25
    ),
    SearchData(
        -2520,
        543910,
        "Stand for an Offering Basin with the Name of King Khafre",
        "offering stand, king khafre|gneiss|",
        "eg/mobile-large/2833.jpg",
        0.55
    ),
    SearchData(
        -2575,
        545821,
        "Group statue",
        "statue group, lower section|limestone|",
        "eg/mobile-large/62.201.2_01.jpg",
        1.20
    ),
    SearchData(
        -167,
        243802,
        "Faience amulet plaque with a group of deities",
        "amulet plaque, group of deities|clay, glazed|gold and silver",
        "gr/mobile-large/DP121845.jpg",
        1.33
    ),
    SearchData(
        -1878,
        544184,
        "Face of Senwosret III",
        "head, senwosret iii; 12th-dyn-king|red quartzite|",
        "eg/mobile-large/DP323868.jpg",
        0.80
    ),
    SearchData(
        -1391,
        544478,
        "Standing figure of Amenhotep III",
        "statuette, standing king, amenhotep iii|chlorite schist|",
        "eg/mobile-large/DP-17706-001.jpg",
        0.71
    ),
    SearchData(
        -2650,
        547429,
        "Model harpoon",
        "model harpoon|copper alloy|",
        "eg/mobile-large/01.4.36_EGDP011633.jpg",
        1.78
    ),
    SearchData(
        -1331,
        544690,
        "Head of Tutankhamun",
        "head, tutankhamun, god\"s hand|indurated limestone|",
        "eg/mobile-large/DT546.jpg",
        0.80
    ),
    SearchData(
        -249,
        547904,
        "Bes-image of the god Hor-Asha-Khet",
        "statuette, bes-image, hor-asha-khet|bronze; gold, electrum, auriferous-silver, copper and copper-alloy inlays|",
        "eg/mobile-large/DP139129.jpg",
        1.00
    ),
    SearchData(
        -1465,
        559832,
        "Scarab Inscribed King of Upper and Lower Egypt Maatkare, Having Dominion",
        "scarab; maatkare, nesut bity, wasti; detailed back|steatite (glazed)|",
        "eg/mobile-large/27.3.250_bot.jpg",
        0.84
    ),
    SearchData(
        -361,
        546751,
        "Bust of an Official",
        "bust, official|greywacke|",
        "eg/mobile-large/25.2.1_EGDP017888.jpg",
        0.67
    ),
    SearchData(
        -1353,
        544060,
        "Attendants in a Procession",
        "talatat, attendants, foreigners|limestone, paint|",
        "eg/mobile-large/DT8198.jpg",
        1.58
    ),
    SearchData(
        -924,
        553738,
        "Statue of the God Reshef",
        "statue, reshef, reshep, foreign, mace, shield, war|limestone|",
        "eg/mobile-large/89.2.215_EGDP011775.jpg",
        0.67
    ),
    SearchData(
        -2649,
        561719,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/LC-10_130_1613_EGDP032327.jpg",
        0.67
    ),
    SearchData(
        149,
        544919,
        "Figure of Isis-Aphrodite",
        "statuette, standing goddess, isis-aphrodite|terracotta painted brown, black, red, and pink on white engobe|",
        "eg/mobile-large/DT6643.jpg",
        0.60
    ),
    SearchData(
        -2465,
        548367,
        "Hand Amulet",
        "amulet, hand|carnelian|",
        "eg/mobile-large/chrDP109378.jpg",
        1.17
    ),
    SearchData(
        -589,
        547705,
        "Relief from the Palace of Apries in Memphis",
        "relief, wall, apries|limestone|",
        "eg/mobile-large/09.183.1a_EGDP011859.jpg",
        0.92
    ),
    SearchData(
        -2649,
        570914,
        "Shell Amulet",
        "amulet, shell|carnelian|",
        "eg/mobile-large/10.130.2435_EGDP021796.jpg",
        1.00
    ),
    SearchData(
        -1311,
        544776,
        "Votive stela of Userhat",
        "stela, userhat|limestone, paint|",
        "eg/mobile-large/DP226728.jpg",
        1.13
    ),
    SearchData(
        -867,
        546227,
        "Bastet on a throne decorated with the decans",
        "statuette, bastet|faience|",
        "eg/mobile-large/LC-44_4_19_EGDP030618.jpg",
        0.67
    ),
    SearchData(
        -2650,
        547427,
        "Model chisel",
        "model chisel|copper alloy|",
        "eg/mobile-large/01.4.34_EGDP011635.jpg",
        1.78
    ),
    SearchData(
        1482,
        702966,
        "Shirt of Mail and Plate of Al-Ashraf Sayf ad-Din Qaitbay (ca. 1416/18–1496), 18th Burji Mamluk Sultan of Egypt",
        "shirt of mail and plate|steel, iron, copper alloy, gold|mail",
        "aa/mobile-large/DP-891-001.jpg",
        0.75
    ),
    SearchData(
        -2650,
        547400,
        "Clay jar sealing Clay jar sealing impressed with name of Khasekhemwy",
        "sealing, jar|clay (unfired)|",
        "eg/mobile-large/01.4.100_EGDP012137.jpg",
        1.25
    ),
    SearchData(
        -2465,
        551279,
        "Bowl",
        "bowl|red polished pottery|",
        "eg/mobile-large/MMA28.2.7.jpg",
        1.55
    ),
    SearchData(
        -2557,
        551049,
        "Box Coffin and Rope",
        "coffin, rope|wood (tamarisk), pigment, fiber|",
        "eg/mobile-large/12.187.54_EGDP015378.jpg",
        1.18
    ),
    SearchData(
        -1371,
        544519,
        "Mechanical Dog",
        "figurine, dog|ivory (elephant)|",
        "eg/mobile-large/0227r2_SEC501K.jpg",
        1.27
    ),
    SearchData(
        -1344,
        544695,
        "Amarna letter: Royal Letter from Ashur-uballit, the king of Assyria, to the king of Egypt",
        "tablet, amarna letter|clay|",
        "eg/mobile-large/24.2.11_EGDP021806.jpg",
        0.75
    ),
    SearchData(
        -1700,
        548325,
        "Double \"Tell el-Yahudiya\" Vase with Incised Lotus Flowers, probably manufactured in Egypt",
        "vase, double, yahudiya ware|pottery, smoke blackening, white gypsum|",
        "eg/mobile-large/23.3.39.jpg",
        1.09
    ),
    SearchData(
        -690,
        549533,
        "Block Statue of Ankhwennefer",
        "block statue, ankhwennefer|limestone|",
        "eg/mobile-large/DT7022.jpg",
        0.80
    ),
    SearchData(
        -175,
        259138,
        "Plaster cast of a metal emblema of Isis-Tyche",
        "cast|plaster|miscellaneous-plaster",
        "gr/mobile-large/sftr236ab2012.jpg",
        0.93
    ),
    SearchData(
        -234,
        547773,
        "Head of Ptolemy II or III",
        "head, ptolemy ii or iii|black bronze|",
        "eg/mobile-large/DP-24219-001.jpg",
        0.81
    ),
    SearchData(
        -945,
        549169,
        "Cult Image of the God Ptah",
        "statuette, ptah|lapis lazuli|",
        "eg/mobile-large/DP142956.jpg",
        0.75
    ),
    SearchData(
        -1390,
        767346,
        "Document Sealing",
        "sealing, amun-re, upper egypt, lower egypt|mud|",
        "eg/mobile-large/SC-PA_203.jpg",
        1.35
    ),
    SearchData(
        -2524,
        543998,
        "Statue of Kaipunesut",
        "statue, kaipunesut|wood, paint|",
        "eg/mobile-large/268829.jpg",
        0.48
    ),
    SearchData(
        -995,
        243741,
        "Faience amulet of Bes image",
        "amulet, bes|clay, glazed|gold and silver",
        "gr/mobile-large/DP121815.jpg",
        0.75
    ),
    SearchData(
        -347,
        243775,
        "Faience snake amulet",
        "amulet, snake|clay, glazed|gold and silver",
        "gr/mobile-large/DP121835.jpg",
        0.75
    ),
    SearchData(
        -1344,
        544693,
        "Face from a Composite Statue, probably Queen Tiye",
        "head, queen tiye|quartzite|",
        "eg/mobile-large/DT11514.jpg",
        0.77
    ),
    SearchData(
        774,
        449211,
        "Panel",
        "panel|wood (fig); mosaic with bone and four different types of wood|wood",
        "is/mobile-large/DP160115.jpg",
        3.32
    ),
    SearchData(
        -2490,
        543935,
        "Seated Statue of King Menkaure",
        "statue, menkaure seated|indurated limestone|",
        "eg/mobile-large/DP109397.jpg",
        0.65
    ),
    SearchData(
        -199,
        246746,
        "Terracotta head of a woman",
        "head of a woman|terracotta|terracottas",
        "gr/mobile-large/DP121877.jpg",
        1.00
    ),
    SearchData(
        -1344,
        544861,
        "Spindle Bottle with Handle",
        "bottle, spindle, handle|glass|",
        "eg/mobile-large/DT2547.jpg",
        0.78
    ),
    SearchData(
        -2650,
        547439,
        "Squat jar",
        "jar|magnesite|",
        "eg/mobile-large/01.4.85_EGDP011686.jpg",
        1.33
    ),
    SearchData(
        -347,
        243753,
        "Faience amulet of Taweret",
        "amulet, thueris|clay, glazed|gold and silver",
        "gr/mobile-large/DP121822.jpg",
        0.75
    ),
    SearchData(
        -1994,
        545393,
        "Stela of the Overseer of the Fortress Intef",
        "stela, intef, iti|limestone|",
        "eg/mobile-large/DP322110.jpg",
        1.72
    ),
    SearchData(
        -347,
        243765,
        "Faience amulet of Ra Horakhty",
        "amulet, hawk|clay, glazed|gold and silver",
        "gr/mobile-large/DP121828.jpg",
        0.75
    ),
    SearchData(
        -2575,
        544531,
        "Facsimile Painting of Geese, Tomb of Nefermaat and Itet",
        "facsimile, nefermaat and itet, meidum geese|tempera on paper|",
        "eg/mobile-large/DT226227.jpg",
        5.70
    ),
    SearchData(
        -2040,
        544207,
        "Sarcophagus of the Hathor Priestess Henhenet",
        "sarcophagus, henhenet|limestone, sandstone, paint|",
        "eg/mobile-large/07.230.1a-b_EGDP011903.jpg",
        1.30
    ),
    SearchData(
        -347,
        243749,
        "Faience amulet of Thoth",
        "amulet, khnum|clay, glazed|gold and silver",
        "gr/mobile-large/DP121821.jpg",
        0.75
    ),
    SearchData(
        -1422,
        554490,
        "Goddess of Upper Egypt",
        "statuette, standing goddess,  upper egypt|ivory|",
        "eg/mobile-large/LC-22_9_4_EGDP028554.jpg",
        0.67
    ),
    SearchData(
        -347,
        243776,
        "Faience snake amulet",
        "amulet, snake|clay, glazed|gold and silver",
        "gr/mobile-large/DP121836.jpg",
        0.75
    ),
    SearchData(
        -361,
        551898,
        "Composite Papyrus Capital",
        "column capital, papyrus|sandstone, paint|",
        "eg/mobile-large/10.177.2_EGDP018080.jpg",
        1.28
    ),
    SearchData(
        -2649,
        552018,
        "Jar with pointed base and intact seal",
        "jar, sealed|pottery|",
        "eg/mobile-large/28.2.20_EGDP010302.jpg",
        0.67
    ),
    SearchData(
        -2650,
        570769,
        "Clay jar sealing impressed faintly with name of Khasekhemwy",
        "sealing, jar|clay (unfired)|",
        "eg/mobile-large/01.4.103_EGDP012117.jpg",
        1.00
    ),
    SearchData(-2649, 569690, "Stake?", "stake (?)|wood|", "eg/mobile-large/97-4-1.jpg", 5.41),
    SearchData(
        -1353,
        566533,
        "Head of Akhenaten or Nefertiti",
        "head, king, queen|gypsum plaster|",
        "eg/mobile-large/DP261897.jpg",
        0.84
    ),
    SearchData(
        -1304,
        545870,
        "Statuette of Kary",
        "statue, kary|wood|",
        "eg/mobile-large/LC-65_114_EGDP030140.jpg",
        0.67
    ),
    SearchData(
        -1390,
        767356,
        "Document Sealing",
        "sealing, amun-re, upper egypt, lower egypt|mud|",
        "eg/mobile-large/SC-PA_213.jpg",
        0.91
    ),
    SearchData(
        -995,
        243794,
        "Faience Wedjat-eye amulet",
        "amulet, eye, udjati|clay, glazed|gold and silver",
        "gr/mobile-large/DP121842.jpg",
        1.33
    ),
    SearchData(
        -1468,
        547684,
        "Artist\"s Gridded Sketch of Senenmut",
        "ostracon, figured, grid, senenmut|limestone, ink|",
        "eg/mobile-large/DT1534.jpg",
        0.81
    ),
    SearchData(
        -1891,
        557549,
        "Coffin of Ameny",
        "coffin, ameny, rectangular|wood, paint|",
        "eg/mobile-large/11.150.39a-b-gc-detail.jpg",
        0.78
    ),
    SearchData(
        -2649,
        551016,
        "Bowl",
        "bowl|pottery|",
        "eg/mobile-large/O.C.2997_EGDP011332.jpg",
        1.78
    ),
    SearchData(
        170,
        547334,
        "Shroud of a Woman Wearing a Fringed Tunic",
        "shroud, woman, fringed tunic|linen, paint (tempera)|",
        "eg/mobile-large/EG198.jpg",
        0.49
    ),
    SearchData(
        -1550,
        555062,
        "Funerary Cone of Heby",
        "cone, circular impression, heby|pottery|",
        "eg/mobile-large/bw13.180.72.jpg",
        1.05
    ),
    SearchData(
        -594,
        545213,
        "Figure of a Baboon",
        "amulet, baboon|faience|",
        "eg/mobile-large/DT8831.jpg",
        0.80
    ),
    SearchData(
        -181,
        544092,
        "Striding Thoth",
        "statuette, thoth|faience|",
        "eg/mobile-large/DP240843.jpg",
        0.75
    ),
    SearchData(
        -1200,
        329885,
        "Pectoral Fragment",
        "|faience|",
        "eg/mobile-large/LC-2021_41_107_EGDP032464.jpg",
        1.50
    ),
    SearchData(
        -2040,
        659735,
        "Fragment of a torus molding from the shrine of a royal woman within the temple of Mentuhotep II",
        "relief, nebhepetre mentuhotep\"s wives, torus molding|limestone, paint|",
        "eg/mobile-large/06.1231.77.jpg",
        2.90
    ),
    SearchData(
        -1465,
        560252,
        "Name Stone of Senenmut",
        "name stone, tally, senenmut|limestone|",
        "eg/mobile-large/36-3-241_ac.jpg",
        0.67
    ),
    SearchData(
        -2649,
        561723,
        "Cylinder seal",
        "cylinder seal|steatite|",
        "eg/mobile-large/LC-10_130_1619_EGDP032398.jpg",
        0.80
    ),
    SearchData(
        -347,
        243716,
        "Jasper amulet in the form of a frog",
        "amulet pendant, frog|jasper|gold and silver",
        "gr/mobile-large/DP121804.jpg",
        0.75
    ),
    SearchData(
        -347,
        244462,
        "Bronze statuette of Osiris",
        "statuette of osiris|bronze|bronzes",
        "gr/mobile-large/DP20095.jpg",
        0.92
    ),
    SearchData(
        -589,
        544884,
        "Fragment of a Royal Head, Probably Apries",
        "head fragment, apries|black diorite|",
        "eg/mobile-large/DT3837.jpg",
        0.80
    ),
    SearchData(
        -347,
        244464,
        "Bronze portrait head of a pharaoh",
        "portrait head of a pharaoh|bronze|bronzes",
        "gr/mobile-large/DP20099.jpg",
        0.92
    ),
    SearchData(
        -1595,
        548350,
        "Bucranium",
        "bucranium, horns, antlers, pan grave, medjayu|horn, bone, paint|",
        "eg/mobile-large/DP100986.jpg",
        1.13
    ),
    SearchData(
        -1473,
        547553,
        "Head from an Osiride Statue of Hatshepsut",
        "head, hatshepsut, niche, double crown; hatshepsut-sculpture|limestone, paint|",
        "eg/mobile-large/21M_CAT074R4.jpg",
        0.79
    ),
    SearchData(
        -1919,
        546275,
        "Canopic Chest of Senbi",
        "canopic chest, senbi|wood (ziziphus sp.), paint, string|",
        "eg/mobile-large/11.150.17a_1-3_0009.jpg",
        0.82
    ),
    SearchData(
        -1390,
        767347,
        "Document Sealing",
        "sealing, upper egypt, lower egypt, amun-re|mud|",
        "eg/mobile-large/SC-PA_204.jpg",
        0.96
    ),
    SearchData(
        -1919,
        544227,
        "Hippopotamus (\"William\")",
        "figurine, hippopotamus (\"william\")|faience|",
        "eg/mobile-large/DP248993.jpg",
        0.75
    ),
    SearchData(
        -2475,
        545825,
        "Headless statue of Babaef as younger man",
        "statue, babaef as younger man|limestone|",
        "eg/mobile-large/64.66.1_EGDP014892.jpg",
        0.50
    ),
    SearchData(
        -1390,
        767351,
        "Document Sealing",
        "sealing, upper egypt, lower egypt, amun-re|mud|",
        "eg/mobile-large/SC-PA_208.jpg",
        0.89
    ),
    SearchData(
        -1966,
        544206,
        "Lintel of Amenemhat I and Deities",
        "relief, lintel, amenemhat i|limestone, paint|",
        "eg/mobile-large/DP322051.jpg",
        3.82
    ),
    SearchData(
        -2639,
        543939,
        "Squat jar with two lugs",
        "jar, squat, two lugs|probably pegmatitic quartz diorite|",
        "eg/mobile-large/24.7.5.jpg",
        1.71
    ),
    SearchData(
        -550,
        553045,
        "Statue of a goddess, probably Nehemetaui or Nebethetepet",
        "statuette, nehemetaui or nebethetepet|cupreous metal|",
        "eg/mobile-large/DP237849.jpg",
        0.75
    ),
    SearchData(
        -2551,
        574407,
        "Block of Relief",
        "relief|limestone, paint|",
        "eg/mobile-large/09.180.6.jpg",
        2.09
    ),
    SearchData(
        -2650,
        551833,
        "Clay jar sealing",
        "sealing, jar|clay (unfired)|",
        "eg/mobile-large/LC-01_4_164_EGDP024739.jpg",
        1.50
    ),
    SearchData(
        -1353,
        544696,
        "Amarna letter: Royal Letter from Abi-milku of Tyre to the king of Egypt",
        "tablet, amarna letter|clay (unfired)|",
        "eg/mobile-large/24.2.12_EGDP021809.jpg",
        0.75
    ),
    SearchData(
        -1465,
        559829,
        "Scarab Inscribed for the King of Upper and Lower Egypt Maatkare (Hatshepsut)",
        "scarab; maatkare, nesut bity; notched back|steatite (glazed)|",
        "eg/mobile-large/27.3.244_bot.jpg",
        0.97
    ),
    SearchData(
        -610,
        546746,
        "Statuette of a Royal (?)  Woman with the Cartouches of Necho II on her Arms",
        "female statuette with cartouches of necho ii on her arms|silver|",
        "eg/mobile-large/DP139132.jpg",
        1.00
    ),
    SearchData(
        -1810,
        545718,
        "Kamares jar",
        "cup, aegean|pottery, paint|",
        "eg/mobile-large/DT327376.jpg",
        0.80
    ),
    SearchData(
        1327,
        444812,
        "Pair of Minbar Doors",
        "doors|wood (rosewood and mulberry); carved and inlaid with carved ivory, ebony, and other woods|wood",
        "is/mobile-large/DP235241.jpg",
        0.64
    ),
    SearchData(
        -347,
        243732,
        "Faience amulet in the form of the dwarf god Pataikos",
        "amulet, ptah-seker|clay, glazed|gold and silver",
        "gr/mobile-large/DP121812.jpg",
        0.75
    ),
    SearchData(
        -351,
        544887,
        "God Horus Protecting King Nectanebo II",
        "statue, horus, king nectanebo ii|meta-greywacke|",
        "eg/mobile-large/DP152085.jpg",
        0.75
    ),
    SearchData(
        1505,
        24426,
        "Standard Head",
        "standard head|steel, iron|shafted weapons",
        "aa/mobile-large/DP158310.jpg",
        0.61
    ),
    SearchData(
        -2551,
        543890,
        "Relief fragment with king Khufu\"s cattle",
        "relief, king khufu\"s cattle|limestone|",
        "eg/mobile-large/DT244362.jpg",
        1.67
    ),
    SearchData(
        -347,
        243769,
        "Faience amulet in the form of a ram",
        "amulet, ram|clay, glazed|gold and silver",
        "gr/mobile-large/DP131208.jpg",
        1.33
    ),
    SearchData(
        -181,
        788904,
        "Three Arrowheads",
        "three arrowheads|bronze|archery equipment-arrowheads",
        "aa/mobile-large/LC-08_99_18-001.jpg",
        1.25
    ),
    SearchData(
        -2051,
        544008,
        "Statue of Nebhepetre Mentuhotep II in the Jubilee Garment",
        "statue, standing king, mentuhotep, nebhepetre|sandstone, paint|",
        "eg/mobile-large/DP302395.jpg",
        0.45
    ),
    SearchData(
        -1070,
        587598,
        "Statue of the God Ptah",
        "statue, ptah|bronze, gold leaf, glass|",
        "eg/mobile-large/DP216330.jpg",
        0.69
    ),
    SearchData(
        -1722,
        557108,
        "Scarab Incised with Hieroglyphs and Scroll",
        "scarab, scroll, wedjat, hieroglyphs, sa, vase|steatite, traces of green glaze|",
        "eg/mobile-large/20.1.138_EGDP020342.jpg",
        0.80
    ),
    SearchData(
        -690,
        547694,
        "Block Statue of a Prophet of Montu and Scribe Djedkhonsuefankh, son of Khonsumes and Taat",
        "block statue, djedkhonsuefankh|gabbro|",
        "eg/mobile-large/DT318224.jpg",
        0.80
    ),
    SearchData(
        -1740,
        544225,
        "Group of two women and a child",
        "statuette group, two women, child|limestone, paint|",
        "eg/mobile-large/DT327377.jpg",
        0.70
    ),
    SearchData(
        -2649,
        565438,
        "Contracted body which has been naturally mummified",
        "body, mummified|human remains, linen|",
        "eg/mobile-large/Images-Restricted.jpg",
        1.00
    ),
    SearchData(
        -698,
        544881,
        "Donation Stela of Shebitqo",
        "stela, shebitqo, donation, patjenef, horus, hathor, hurbeit|limestone|",
        "eg/mobile-large/EG65.45.JPG",
        1.10
    ),
    SearchData(
        -1329,
        544692,
        "Haremhab as a Scribe of the King",
        "statue, scribe, haremhab|granodiorite|",
        "eg/mobile-large/DP238391.jpg",
        0.67
    ),
    SearchData(
        -347,
        243745,
        "Faience amulet of Isis and Horus",
        "amulet, isis|clay, glazed|gold and silver",
        "gr/mobile-large/DP121840.jpg",
        0.75
    ),
    SearchData(
        -1000,
        548253,
        "Wedjat Eye Incision Plaque",
        "amulet plaque, wedjat eye, gautsoshen|bronze or copper alloy|",
        "eg/mobile-large/62415.jpg",
        1.22
    ),
    SearchData(
        275,
        466645,
        "Medallion with a Portrait of Gennadios",
        "medallion|glass, gold leaf, polychromy|glass-gold glass",
        "md/mobile-large/DP325825.jpg",
        0.99
    ),
    SearchData(
        -2550,
        543871,
        "Head of a statue of an older man",
        "head, male statue|limestone, paint|",
        "eg/mobile-large/DT259188.jpg",
        0.75
    ),
    SearchData(
        -347,
        243754,
        "Faience amulet of Taweret",
        "amulet, thueris|clay, glazed|gold and silver",
        "gr/mobile-large/DP121823.jpg",
        0.75
    ),
    SearchData(
        -2650,
        547398,
        "Clay jar sealing impressed with name of Khasekhemwy",
        "sealing, jar|clay (unfired)|",
        "eg/mobile-large/01.4.98_EGDP012127.jpg",
        1.78
    ),
    SearchData(
        -1371,
        544498,
        "Sphinx of Amenhotep III, possibly from a Model of a Temple",
        "sphinx, amenhotep iii|faience, remains of a travertine (egyptian alabaster) tenon|",
        "eg/mobile-large/DT539.jpg",
        1.25
    ),
    SearchData(
        -1400,
        243816,
        "Mirror handle",
        "handle of a mirror with lotus petals|clay, glazed|terracottas",
        "gr/mobile-large/DP121848.jpg",
        1.33
    ),
    SearchData(
        -2551,
        551276,
        "Temple relief",
        "temple relief, names of khufu|limestone|",
        "eg/mobile-large/LC-22_1_19_EGDP030917.jpg",
        1.50
    ),
    SearchData(
        -2649,
        551010,
        "Cup",
        "cup|pottery|",
        "eg/mobile-large/28.2.30_EGDP011316.jpg",
        0.80
    ),
    SearchData(
        -2500,
        543887,
        "Shallow bowl with a recurved rim",
        "bowl|travertine (egyptian alabaster)|",
        "eg/mobile-large/DT227150.jpg",
        1.25
    ),
    SearchData(
        0,
        547376,
        "Bracelet with Agathodaimon, Isis-Tyche, Aphrodite, and Thermouthis",
        "bracelet, agathodaimon, isis-tyche, aphrodite, thermouthis|gold|",
        "eg/mobile-large/DP-14787-002.jpg",
        0.89
    ),
    SearchData(
        1274,
        444540,
        "Brazier of Rasulid Sultan al-Malik al-Muzaffar Shams al-Din Yusuf ibn \"Umar",
        "brazier|brass; cast, chased, and inlaid with silver and black compound|metal",
        "is/mobile-large/DP170388.jpg",
        1.03
    ),
    SearchData(
        -493,
        243949,
        "Faience figurine of a lion",
        "pendant ? of a lion|faience|miscellaneous-faience",
        "gr/mobile-large/DP121850.jpg",
        1.33
    ),
    SearchData(
        -2005,
        548212,
        "Relief of Nebhepetre Mentuhotep II and the Goddess Hathor",
        "relief, temple wall, mentuhotep ii|limestone, paint|",
        "eg/mobile-large/DP322047.jpg",
        2.53
    ),
    SearchData(
        -2267,
        590943,
        "Two Vases in the Shape of a Mother Monkey with her Young",
        "vase, monkey, baby|travertine (egyptian alabaster), paint, resin and pigment|",
        "eg/mobile-large/eg30.8.134_1992.338.jpg",
        0.80
    ),
    SearchData(
        -688,
        243777,
        "Faience ram\"s head amulet",
        "amulet, ram\"s head|clay, glazed|gold and silver",
        "gr/mobile-large/DP121837.jpg",
        0.75
    ),
    SearchData(
        -1363,
        544514,
        "Fragment of a Queen\"s Face",
        "head, queen, fragment, lips|yellow jasper|",
        "eg/mobile-large/DP355835.jpg",
        0.88
    ),
    SearchData(
        -347,
        243773,
        "Faience amulet in the form of a hare",
        "amulet, hare|clay, glazed|gold and silver",
        "gr/mobile-large/DP121832.jpg",
        1.33
    ),
    SearchData(
        325,
        465921,
        "Bowl Fragments with Menorah, Shofar, and Torah Ark",
        "bowl fragments|glass, gold leaf|glass-gold glass",
        "md/mobile-large/h1_18.145.1ab.jpg",
        1.28
    ),
    SearchData(
        65,
        547257,
        "Mummy Mask",
        "mask, cartonnage, woman|cartonnage, plaster, paint, plant fibers|",
        "eg/mobile-large/DT10852.jpg",
        0.80
    ),
    SearchData(
        -1045,
        243739,
        "Faience amulet of Bes image",
        "amulet, bes|clay, glazed|gold and silver",
        "gr/mobile-large/DP131207.jpg",
        0.75
    ),
    SearchData(
        -1186,
        544076,
        "Artist\"s Sketch of Pharaoh Spearing a Lion",
        "ostracon, figured, pharaoh, lion, hieratic|limestone, ink|",
        "eg/mobile-large/1191R2_Sec501M.jpg",
        1.08
    ),
    SearchData(
        312,
        463989,
        "Gold Glass Medallion with a Mother and Child",
        "medallion|glass, gold  leaf|glass-gold glass",
        "md/mobile-large/sf17-190-109as1.jpg",
        0.99
    ),
    SearchData(
        -1390,
        548584,
        "Cosmetic Spoon in the Shape of Swimming Woman Holding a Dish",
        "cosmetic spoon, swimming woman, gazelle|travertine (egyptian alabaster), steatite|",
        "eg/mobile-large/DT223706.jpg",
        1.25
    ),
    SearchData(
        -2557,
        551045,
        "Drinking Cup",
        "cup, spouted|limestone|",
        "eg/mobile-large/10.176.143_EGDP015841.jpg",
        1.00
    ),
    SearchData(
        1049,
        448401,
        "Crescent-Shaped Pendant with Confronted Birds",
        "pendant|gold, cloisonné enamel, turquoise; filigree|jewelry",
        "is/mobile-large/DP170371.jpg",
        0.80
    ),
    SearchData(
        -1944,
        544320,
        "Stela of the Steward Mentuwoser",
        "stela, mentuwoser|limestone, paint|",
        "eg/mobile-large/DP322064.jpg",
        0.52
    ),
    SearchData(
        -1003,
        552609,
        "Winged Goddess",
        "winged goddess|faience|",
        "eg/mobile-large/26.7.982a-c_EGDP011734.jpg",
        1.50
    ),
    SearchData(
        -1342,
        546194,
        "Arched Harp (shoulder harp)",
        "music, harp, arched, naviform, boat shaped|wood|",
        "eg/mobile-large/DP302724.jpg",
        0.75
    ),
    SearchData(
        -313,
        547689,
        "Ritual Figure",
        "statuette, ritual figure|wood, formerly clad with lead sheet|",
        "eg/mobile-large/DT1016.jpg",
        0.80
    ),
    SearchData(
        -1465,
        548957,
        "Name Stone of Senenmut",
        "name stone, tally, senenmut|limestone, paint|",
        "eg/mobile-large/36-3-245_ac.jpg",
        0.83
    ),
    SearchData(
        -1700,
        545108,
        "Head from a Large Statue of a Priest or Dignitary",
        "head, priest or dignitary|quartzite|",
        "eg/mobile-large/262112.jpg",
        0.82
    ),
    SearchData(
        -2880,
        545799,
        "Stela of Raneb",
        "stela, raneb|granite|",
        "eg/mobile-large/DP259528.jpg",
        0.55
    ),
    SearchData(
        -995,
        243808,
        "Openwork faience ring",
        "ring, openwork faience|faience|gold and silver",
        "gr/mobile-large/DP121846.jpg",
        0.75
    ),
    SearchData(
        -351,
        546037,
        "Magical Stela (Cippus of Horus)",
        "cippus, cippus of horus|meta-greywacke|",
        "eg/mobile-large/DP319007.jpg",
        0.79
    ),
    SearchData(
        -2649,
        543881,
        "Weight equal to five deben",
        "weight, 5 deben|yellow jasper or opal|",
        "eg/mobile-large/DT259187.jpg",
        0.80
    ),
    SearchData(
        -2649,
        552020,
        "Large jar",
        "jar|pottery|",
        "eg/mobile-large/28.2.9_EGDP010299.jpg",
        0.67
    ),
    SearchData(
        -867,
        544078,
        "Amulet in the Form of a Lion-Headed Goddess",
        "amulet, lion headed goddess|faience|",
        "eg/mobile-large/DT226125.jpg",
        0.80
    ),
    SearchData(
        1049,
        446191,
        "Panel with Horse Heads",
        "panel|wood (teak); carved|wood",
        "is/mobile-large/DP170363.jpg",
        0.75
    ),
    SearchData(
        -1390,
        767342,
        "Document Sealing",
        "sealing, amun-re, upper egypt, lower egypt|mud|",
        "eg/mobile-large/SC-PA_199.jpg",
        1.23
    ),
    SearchData(
        149,
        590953,
        "Theatrical Masks and Ram Vessel for Offering",
        "mask, theatrical, ram vessel|faience|",
        "eg/mobile-large/26.7.1019-group_EGDP011909.jpg",
        0.92
    ),
    SearchData(
        -2650,
        547433,
        "Copper pin?",
        "cosmetic pin (?)|copper alloy|",
        "eg/mobile-large/01.4.40_EGDP011663.jpg",
        1.78
    ),
    SearchData(
        -525,
        544070,
        "Antelope Head",
        "head, antelope|greywacke, travertine (egyptian alabaster), agate|",
        "eg/mobile-large/DT6857.jpg",
        1.25
    ),
    SearchData(
        -2575,
        543994,
        "Scenes from a King\"s Thirty-Year Jubilee",
        "relief, snefru (?), heb-sed|limestone, paint|",
        "eg/mobile-large/DT259173.jpg",
        1.33
    ),
    SearchData(-2649, 550160, "Bowl", "bowl|granodiorite|", "eg/mobile-large/2001.726.2.jpg", 1.57),
    SearchData(
        -2458,
        543936,
        "Palm Column of Sahure",
        "column, sahure, palm capital|granite|",
        "eg/mobile-large/10.175.137_EGDP011910.jpg",
        0.67
    ),
    SearchData(
        -182,
        250525,
        "Fragmentary faience statuette of Aphrodite",
        "statuette of aphrodite, fragment|faience|miscellaneous-faience",
        "gr/mobile-large/DP121794.jpg",
        1.33
    ),
    SearchData(
        -5,
        551807,
        "Man Holding a Shrine Containing an Image of Osiris",
        "statue, priest, osiris shrine|greywacke|",
        "eg/mobile-large/DP152079.jpg",
        0.75
    ),
    SearchData(
        -1390,
        767350,
        "Document Sealing",
        "sealing, upper egypt, lower egypt, amun-re|mud|",
        "eg/mobile-large/SC-PA_207.jpg",
        0.91
    ),
)